import React from "react";

const CustomDateTimePicker = (props) => {
   const {
      label,
      id,
      onChange,
      name,
      value,
      disabled,
      require,
      errors,
      message,
      min,
   } = props;
   return (
      <div className="form-group">
         {label && (
            <label className="text-capitalize">
               {label}
               {require && <span className="text-danger">*</span>}
            </label>
         )}
         <input
            type="datetime-local"
            className="form-control"
            disabled={disabled}
            name={name}
            onChange={onChange}
            id={id}
            value={value}
            min={min}
         />
         {errors && (
            <div className="text-danger" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </div>
   );
};

export default CustomDateTimePicker;
